/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbSyncLogFilters {
    getFixupPrototypeFunction() { return ServiceNowCmdbSyncLogFilters.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbSyncLogFilters>): ServiceNowCmdbSyncLogFilters {
        let obj = Object.assign(new ServiceNowCmdbSyncLogFilters(), model);
        ServiceNowCmdbSyncLogFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbSyncLogFilters>): ServiceNowCmdbSyncLogFilters {
        if (!model) return null;
        return ServiceNowCmdbSyncLogFilters.newInstance(<ServiceNowCmdbSyncLogFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbSyncLogFilters) {
        if (!obj) return;

        models.ServiceNowCmdbSyncLogFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbSyncLogFilters): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbSyncLogFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * action for CMDB logs dashboard
     */
    action: models.ServiceNowCmdbSyncLogAction;

    /**
     * Cloud Account ID
     */
    service_account_id: string;

    /**
     * ServiceNow Account ID
     */
    snow_account_id: string;

    query: models.QueryOperator;

}
